import gql from 'graphql-tag';

const CREATE_EMERGENCY_CONTACT = gql`
  mutation CreateEmergencyContact($data: CreateEmergencyContactInput!) {
    createEmergencyContact(data: $data) {
      id
      type
      name
      note
      phoneNumbers
      contactIdentifier
      email
      confirmation_code
      duress_code
      cra_code
      image
    }
  }
`;

const UPDATE_EMERGENCY_CONTACT = gql`
  mutation UpdateEmergencyContactById(
    $id: ID!
    $data: UpdateEmergencyContactInput
  ) {
    updateEmergencyContactById(id: $id, data: $data) {
      id
      name
      note
      phoneNumbers
      contactIdentifier
      email
      confirmation_code
      duress_code
      cra_code
      image
      custom {
        id
        name
        note
        phoneNumbers
        contactIdentifier
        email
        confirmation_code
        duress_code
        cra_code
      }
    }
  }
`;

const DELETE_EMERGENCY_CONTACT_BY_ID = gql`
  mutation DeleteEmergencyContactById($id: ID!) {
    deleteEmergencyContactById(id: $id) {
      id
      name
    }
  }
`;

export default {
  CREATE_EMERGENCY_CONTACT,
  DELETE_EMERGENCY_CONTACT_BY_ID,
  UPDATE_EMERGENCY_CONTACT,
};
